/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'attractiveness' }, { id: 'boring' }, { id: 'unsure' }, { id: 'hairline' }, { id: 'sameCut' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-holding-back"
      progress={10}
      field="hairstyleHoldingBack"
      setter="setHairstyleHoldingBack"
      ns="hairstyleHoldingBack"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
